// Undo/redo history for the build config, and a media-query hook. Moved out of App.js unchanged.
import { useEffect, useReducer, useState } from 'react'

// ————— History reducer (no TEMP) —————————————
export function historyReducer(state, action) {
  const { past, present, future } = state
  switch (action.type) {
    case 'SET':
      return { past: [...past, present], present: action.payload, future: [] }
    case 'UNDO':
      if (!past.length) return state
      const previous = past[past.length - 1]
      return { past: past.slice(0, -1), present: previous, future: [present, ...future] }
    case 'REDO':
      if (!future.length) return state
      const next = future[0]
      return { past: [...past, present], present: next, future: future.slice(1) }
    default:
      return state
  }
}

export function useHistory(initial) {
  const [state, dispatch] = useReducer(historyReducer, {
    past: [],
    present: initial,
    future: []
  })

  const set = (payload) => dispatch({ type: 'SET', payload })
  const undo = () => dispatch({ type: 'UNDO' })
  const redo = () => dispatch({ type: 'REDO' })
  const canUndo = state.past.length > 0
  const canRedo = state.future.length > 0

  return [state.present, set, { undo, redo, canUndo, canRedo }]
}

// eslint-disable-line no-unused-vars

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false
    return window.matchMedia(query).matches
  })

  useEffect(() => {
    const media = window.matchMedia(query)
    setMatches(media.matches)

    let timer = null
    const listener = () => {
      clearTimeout(timer)
      timer = setTimeout(() => setMatches(media.matches), 300)
    }
    media.addEventListener('change', listener)

    return () => {
      clearTimeout(timer)
      media.removeEventListener('change', listener)
    }
  }, [query])

  return matches
}

